var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 70,
    viewBox: "0 0 104 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7543 22.3656C74.7543 34.7177 64.7448 44.7311 52.3974 44.7311C40.05 44.7311 30.0404 34.7177 30.0404 22.3656C30.0404 10.0134 40.05 0 52.3974 0C64.7448 0 74.7543 10.0134 74.7543 22.3656ZM41.651 17.499H36.7388L42.0918 10.3798H51.4755V21.6571H49.0823V34.3205H41.651V17.499ZM62.5595 10.3799L67.9125 17.4991H63.0003V34.3205H55.569V21.6572H53.1758V10.3799H62.5595Z",
    fill: "url(#paint0_linear_136_2357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53419 56.724L0 57.1665V54.2901L6.08247 53.405L12.1649 54.2901V57.1665L7.74131 56.724V69.6681H4.42361V56.724H4.53419Z",
    fill: "url(#paint1_linear_136_2357)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1415 58.2729C20.4592 58.2729 22.671 60.7068 22.671 64.3577V65.0215H14.3767C14.5979 66.4597 15.7038 67.566 17.5839 67.566C18.5792 67.566 19.7957 67.1235 20.5698 66.4597L21.8969 68.3405C20.791 69.3362 19.0215 69.8893 17.3627 69.8893C13.9344 69.8893 11.3908 67.566 11.3908 64.0258C11.2802 60.8174 13.7132 58.2729 17.1415 58.2729ZM14.3767 63.0301H19.9063C19.7957 61.9238 19.1321 60.5962 17.1415 60.5962C15.2615 60.5962 14.4873 61.9238 14.3767 63.0301Z",
    fill: "url(#paint2_linear_136_2357)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7722 54.2901H27.6476V69.6681H24.7722V54.2901Z",
    fill: "url(#paint3_linear_136_2357)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6101 58.2729C38.9278 58.2729 41.1396 60.7068 41.1396 64.3577V65.0215H32.8453C33.0665 66.4597 34.1724 67.566 36.0524 67.566C37.0478 67.566 38.2643 67.1235 39.0384 66.4597L40.3655 68.3405C39.2596 69.3362 37.4901 69.8893 35.8313 69.8893C32.403 69.8893 29.8594 67.566 29.8594 64.0258C29.8594 60.8174 32.2924 58.2729 35.6101 58.2729ZM32.8453 63.0301H38.3748C38.2642 61.9238 37.6007 60.5962 35.6101 60.5962C33.8406 60.5962 33.0665 61.9238 32.8453 63.0301Z",
    fill: "url(#paint4_linear_136_2357)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8997 56.724L40.3655 57.1665V54.2901L46.4479 53.405L52.5304 54.2901V57.1665L48.1068 56.724V69.6681H44.7891V56.724H44.8997Z",
    fill: "url(#paint5_linear_136_2357)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0834 58.4941H55.9587V60.043C56.7328 59.0473 58.1705 58.2729 59.4976 58.2729V61.1493C59.2764 61.1493 59.0552 61.0387 58.7235 61.0387C57.7281 61.0387 56.5117 61.5919 55.9587 62.2557V69.5574H53.0834V58.4941Z",
    fill: "url(#paint6_linear_136_2357)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.013 68.5617C67.2389 69.4468 65.9118 70 64.4742 70C62.7047 70 60.6035 68.783 60.6035 66.3491C60.6035 63.6939 62.7047 62.8088 64.4742 62.8088C65.9118 62.8088 67.2389 63.2514 68.013 64.1364V62.5876C68.013 61.4812 67.0177 60.7068 65.5801 60.7068C64.3636 60.7068 63.2577 61.1493 62.3729 62.0344L61.267 60.043C62.5941 58.826 64.3636 58.2729 66.133 58.2729C68.6766 58.2729 70.999 59.2686 70.999 62.4769V69.6681H68.013V68.5617ZM68.013 65.5746C67.5707 64.9108 66.5754 64.5789 65.6906 64.5789C64.5847 64.5789 63.5894 65.1321 63.5894 66.2384C63.5894 67.2341 64.5847 67.8979 65.6906 67.8979C66.686 67.8979 67.5707 67.566 68.013 66.9022V65.5746Z",
    fill: "url(#paint7_linear_136_2357)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5051 68.2298C80.6203 69.3362 79.4039 69.8893 78.0768 69.8893C75.312 69.8893 73.1002 67.7873 73.1002 64.0258C73.1002 60.3749 75.2014 58.1622 78.0768 58.1622C79.4039 58.1622 80.6203 58.7154 81.5051 59.8217V54.1795H84.491V69.5574H81.5051V68.2298ZM81.5051 62.145C81.0627 61.3706 79.9568 60.9281 78.9615 60.9281C77.3026 60.9281 76.1967 62.2557 76.1967 64.1364C76.1967 66.0172 77.3026 67.3448 78.9615 67.3448C79.9568 67.3448 81.0627 66.7916 81.5051 66.1278V62.145Z",
    fill: "url(#paint8_linear_136_2357)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0346 55.1752C87.0346 54.1795 87.8087 53.405 88.804 53.405C89.7993 53.405 90.5735 54.1795 90.5735 55.1752C90.5735 56.1709 89.7993 56.9453 88.804 56.9453C87.8087 56.9453 87.0346 56.1709 87.0346 55.1752ZM87.3663 58.4941H90.2417V69.6681H87.3663V58.4941Z",
    fill: "url(#paint9_linear_136_2357)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2042 58.2729C101.522 58.2729 103.734 60.7068 103.734 64.3577V65.0215H95.4394C95.6606 66.4597 96.7665 67.566 98.6466 67.566C99.6419 67.566 100.858 67.1235 101.632 66.4597L102.96 68.3405C101.854 69.3362 100.084 69.8893 98.4254 69.8893C94.9971 69.8893 92.4535 67.566 92.4535 64.0258C92.4535 60.8174 94.7759 58.2729 98.2042 58.2729ZM95.4394 63.0301H100.969C100.858 61.9238 100.195 60.5962 98.2042 60.5962C96.3242 60.5962 95.55 61.9238 95.4394 63.0301Z",
    fill: "url(#paint10_linear_136_2357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_2357",
    x1: 75.1009,
    y1: 22.3656,
    x2: 30.0404,
    y2: 22.3656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0670CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_136_2357",
    x1: 103.734,
    y1: 62.2325,
    x2: -0.343069,
    y2: 62.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0670CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_136_2357",
    x1: 103.734,
    y1: 62.2325,
    x2: -0.343069,
    y2: 62.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0670CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_136_2357",
    x1: 103.734,
    y1: 62.2325,
    x2: -0.343069,
    y2: 62.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0670CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_136_2357",
    x1: 103.734,
    y1: 62.2325,
    x2: -0.343069,
    y2: 62.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0670CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_136_2357",
    x1: 103.734,
    y1: 62.2325,
    x2: -0.343069,
    y2: 62.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0670CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_136_2357",
    x1: 103.734,
    y1: 62.2325,
    x2: -0.343069,
    y2: 62.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0670CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_136_2357",
    x1: 103.734,
    y1: 62.2325,
    x2: -0.343069,
    y2: 62.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0670CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_136_2357",
    x1: 103.734,
    y1: 62.2325,
    x2: -0.343069,
    y2: 62.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0670CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_136_2357",
    x1: 103.734,
    y1: 62.2325,
    x2: -0.343069,
    y2: 62.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0670CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_136_2357",
    x1: 103.734,
    y1: 62.2325,
    x2: -0.343069,
    y2: 62.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0670CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVertical);
export default __webpack_public_path__ + "static/media/logo-vertical.ecaa005564f4b788c72804f2b01bb511.svg";
export { ForwardRef as ReactComponent };